import React, { Component } from "react";
//import Moment from 'react-moment';
import { css } from "aphrodite";
import { styles } from "./EnergyServicesHomeStyles";
import Header from "../components/Header";
import EnergyServicesNavigation from "../components/EnergyServicesNavigation";
import PageTitle from "../components/PageTitle";
import FeedbackPanel from "../components/FeedbackPanel";
import PopupWrapper from "../components/PopupWrapper";

class EnergyServicesFeedback extends Component {
  render() {
    return (
      <div>
        <Header
          title={"My Home"}
          backTitle={"Dashboard"}
          backHref={"/"}
          isHomeView={true}
        />
        <PageTitle
          title={"Feedback"}
          subTitle={"We care about all of your feedback."}
        />
        <EnergyServicesNavigation {...this.props.location} />
        <div className={css(styles.innerNarrow)}>
          <PopupWrapper />
          <FeedbackPanel {...this.props} user="user" />
        </div>
      </div>
    );
  }
}

export default EnergyServicesFeedback;
